// extracted by mini-css-extract-plugin
module.exports = {"passwordsRow":"Register_passwordsRow__WOvC0","rowResponsive":"Register_rowResponsive__1MlzP","newsLetter":"Register_newsLetter__1xBLg"};